import React, { Component, Children } from 'react'
import { Switch, NavLink } from 'react-router-dom'

export default class Tabs extends Component {
  render () {
    const {children} = this.props

    return <div className='tabs'>
      <ul>
        {Children.map(children, ({props: {title, path}}) =>
          <li><NavLink to={path} exact>{title}</NavLink></li>
        )}
      </ul>
      <Switch>
        {children}
      </Switch>
    </div>
  }
}



// WEBPACK FOOTER //
// ./app/components/ui/Tabs.js